import { Mark } from '@tiptap/core'

export const RedMark = Mark.create({
    name: 'redMark',
    
    addOptions() {
        return {
            HTMLAttributes: {
                'data-red-mark': 'true',
                style: 'border: solid red 2px; padding: 2px; display: inline;',
            },
        }
    },
    
    parseHTML() {
        return [
            {
                tag: 'span[data-red-mark="true"]',
                getAttrs: (node) => {
                    return node.getAttribute('data-red-mark') === 'true' ? {} : false;
                },
            },
            {
                tag: 'span[style*="border: solid red 2px"]',
                getAttrs: (node) => {
                    if (!node.style) return false;
                    const styleText = node.style.cssText || '';
                    return styleText.includes('border: solid red 2px') ? {} : false;
                },
            },
        ]
    },
    
    renderHTML({ HTMLAttributes }) {
        return ['span', { ...this.options.HTMLAttributes, ...HTMLAttributes }, 0]
    },
    
    addCommands() {
        return {
            setRedMark: () => ({ commands }) => {
                return commands.setMark(this.name)
            },
            toggleRedMark: () => ({ commands }) => {
                return commands.toggleMark(this.name)
            },
            unsetRedMark: () => ({ commands }) => {
                return commands.unsetMark(this.name)
            },
        }
    },
})

